/* Lawazen Next - document catalogue: brand and range catalogues.
   These were already in Shopify Files before the 2026 material upload; they are
   the only place a customer can browse a whole range in one document.
   Row shape matches materials: [name, family, [[type, filename], ...]] */
window.LZ_DOCS = window.LZ_DOCS || {};
LZ_DOCS.catalogues = [
["Trotec materials","trotec",[["cat","Low_res_Materialcatalog_2019_TEC-EN.pdf"]]],
["Laserable products","trotec",[["cat","Laserable_Products_Catalogue_2014.pdf"]]],
["Trotec Speedy range","trotec",[["cat","2023-11-catalog-speedy-TEC-EN_01_3.pdf"]]],
["Trotec SpeedMarker range","trotec",[["cat","2023-05-Catalog-SpeedMarker-TEC-EN.pdf"]]],
["Trotec SP range","trotec",[["cat","catalog-sp-series-TEC-EN.pdf"]]],
["Trodat 2025","trodat",[["cat","1002834_CA_Trodat_2025_EN_master-compressed.pdf"]]],
["Trodat 2023","trodat",[["cat","Open_190054_CA_Trodat_2023_GB_master_compressed.pdf"]]],
["Sawgrass VersiFlex","sawgrass",[["cat","VersiFlex_Catalog.pdf"]]]
];
